import { render, staticRenderFns } from "./BurnFluidResuscitation.vue?vue&type=template&id=5585fa4e&scoped=true&"
import script from "./BurnFluidResuscitation.vue?vue&type=script&lang=js&"
export * from "./BurnFluidResuscitation.vue?vue&type=script&lang=js&"
import style0 from "./BurnFluidResuscitation.vue?vue&type=style&index=0&id=5585fa4e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5585fa4e",
  null
  
)

export default component.exports